import { useState } from 'react';
import { message } from 'antd';
import { ResourcesType } from 'common/components/DocumentHolder';

export interface ResourceProp {
  uuid: string;
  name: string;
  url: string;
  scene: string;
  tags?: string[];
  size: number;
  uploaderName: string;
  uploadTime: string;
  relationCount: number;
  pptCoverUrl: string;
}

interface FetchParamsProp {
  pageNo?: number;
  pageSize?: number;
  orderBy?: string;
  order?: string;
  keyword?: string;
  scene?: string;
}

interface PostParamsProp {
  name: string;
  scene: string;
  tags?: string[];
}

function useBizResource() {
  const [resources, setResources] = useState<ResourceProp[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [filterData, setFilterData] = useState<any>({});
  const [loadDigitalUrlUuids, setLoadDigitalUrlUuids] = useState<string[]>([]);
  const [digitalUrlProgress, setDigitalUrlProgress] = useState<any[]>([]);
  const [convertingPptCount, setConvertingPptCount] = useState(0);

  const fetchResources = (
    courseUuid: string,
    type = 'IMAGE',
    fetchParams: FetchParamsProp,
    afterSuccessCallback?: () => void
  ) => {
    const params = {
      biz: 'TEACHING_RESOURCE',
      type: type.toUpperCase(),
      ...fetchParams,
    };
    const url =
      window.alo7Api.prefix.host +
      `/api/v1/course_${window.alo7Nav.subject}/${courseUuid}/resources` +
      window.alo7Nav.objectToSearchString(params);

    window.alo7Api
      .fetch(url)
      .then(res => {
        setTotalCount(res.totalCount);
        setResources(res.result);
        nx.$root.catalog.resources = res.result;
        const _loadDigitalUrlUuids: string[] = [];
        res.result.map((item: any) => {
          if (
            ResourcesType[
              item.name
                .toLowerCase()
                .split('.')
                .slice(-1)
                .join('.')
            ]
          ) {
            _loadDigitalUrlUuids.push(item.uuid);
          }
        });
        setLoadDigitalUrlUuids(_loadDigitalUrlUuids);
        if (afterSuccessCallback) afterSuccessCallback();
      })
      .catch(res => message.error(res.message));
  };

  const postToEditResource = (
    courseUuid: string,
    resourceUuid: string,
    type: string,
    postParams: PostParamsProp,
    afterSuccessCallback?: () => void
  ) => {
    const params = {
      biz: 'TEACHING_RESOURCE',
      type: type.toUpperCase(),
      resourceUuid,
      ...postParams,
    };
    const url =
      window.alo7Api.prefix.host +
      `/api/v1/course_${window.alo7Nav.subject}/${courseUuid}/edit_resource`;
    window.alo7Api
      .fetch(url, {
        method: 'post',
        body: JSON.stringify(params),
      })
      .then(res => {
        if (afterSuccessCallback) afterSuccessCallback();
      })
      .catch(res => message.error(res.message));
  };

  const fetchResourceFilterOptions = () => {
    const url =
      window.alo7Api.prefix.host + `/api/v1/resources_${window.alo7Nav.subject}/course_filters`;
    window.alo7Api.fetch(url).then(res => {
      setFilterData(res);
    });
  };

  const removeResource = (
    courseUuid: string,
    resourceUuid: string,
    type: string,
    afterSuccessCallback?: () => void
  ) => {
    const url =
      window.alo7Api.prefix.host +
      `/api/v1/course_${window.alo7Nav.subject}/${courseUuid}/remove_resource`;
    alo7Api
      .fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          biz: 'TEACHING_RESOURCE',
          resourceUuid,
          type: type.toUpperCase(),
        }),
      })
      .then(res => {
        message.success('删除成功');
        if (afterSuccessCallback) afterSuccessCallback();
      })
      .catch(res => message.error(res.message));
  };

  const loadDigitalPptUrlProgress = () => {
    nx.$api
      .ppt_convert_progress_list({
        subject: alo7Nav.subject,
        parmas: alo7Nav.objectToSearchString({
          resourceUuids: loadDigitalUrlUuids,
        }),
      })
      .then((res: any) => {
        setDigitalUrlProgress(res);
        let _convertingPptCount = 0;
        res.map((item: { digitalConversionProgress: number }) => {
          if (item.digitalConversionProgress >= 0 && item.digitalConversionProgress !== 100) {
            _convertingPptCount += 1;
          }
        });
        if (_convertingPptCount === 0) {
          window.dispatchEvent(new CustomEvent('cleanPptUrlProgressInterval'));
        }
        setConvertingPptCount(_convertingPptCount);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  return {
    resources,
    setResources,
    totalCount,
    setTotalCount,
    filterData,
    fetchResources,
    fetchResourceFilterOptions,
    loadDigitalPptUrlProgress,
    removeResource,
    postToEditResource,
    loadDigitalUrlUuids,
    digitalUrlProgress,
    convertingPptCount,
  };
}

export default useBizResource;
